var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolderSimpleUser = function SvgIconFolderSimpleUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18.5V6.25h4.664l2.54 1.9.002.002a1.76 1.76 0 0 0 1.043.348H20v1.625a1 1 0 1 0 2 0V8.25a1.75 1.75 0 0 0-1.75-1.75h-7.914l-2.54-1.9-.002-.002A1.76 1.76 0 0 0 8.75 4.25H3.75A1.75 1.75 0 0 0 2 6v12.75a1.75 1.75 0 0 0 1.75 1.75h6.75a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.375 16.125c0 .802.29 1.537.773 2.104a4 4 0 0 0-1.398 2.148 1 1 0 0 0 1.938.496 2 2 0 0 1 1.816-1.5 3 3 0 0 0 .242 0 2 2 0 0 1 1.817 1.5 1 1 0 0 0 1.937-.496 4 4 0 0 0-1.398-2.148 3.25 3.25 0 1 0-5.727-2.104m3.25-1.25a1.25 1.25 0 0 0-.106 2.496 4 4 0 0 1 .212 0 1.25 1.25 0 0 0-.106-2.496",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFolderSimpleUser;